import script from "./Co2QuizView.vue?vue&type=script&lang=ts&setup=true"
export * from "./Co2QuizView.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__